export const ValidationType = {
    // check if the value is empty and/or the value is Please Select/Choose
    IsRequired: 'IsRequired',
    // check if the value is purely digits
    AllDigit: 'AllDigit',
    // valid number
    ValidNumber: 'ValidNumber',
    // valid date
    ValidDate: 'ValidDate',
    // phone num
    ValidPhoneNumber: 'ValidPhoneNumber',
    ValidEmail: 'ValidEmail',
    ValidYear: 'ValidYear',
    ValidMobilePhone: 'ValidMobilePhone',
    // special to Mode of Travel for Returning on travel details of AFR
    // as default value is 6, which will never be ''
    ValidTravelMode: 'ValidTravelMode',
    // as sometimes value for id is 0 rather than ''
    ValidId: 'ValidId',
    ValidTime: 'ValidTime',
};